import { ProjectDetailsDto } from 'types/projects.ts';
import { RSQL_AND } from 'utils/filterUtil.ts';
import TimecardListWithFilters from '../../timecards/TimecardListWithFilters.tsx';

type Props = {
    project: ProjectDetailsDto;
};

const TimecardsView = ({ project }: Props) => {
    const matterIds = project.matters?.map((m) => m.id) ?? [];
    const joinedMatterIds = matterIds.length > 0 ? matterIds.join(',') : '0';
    return (
        <div className="flex h-full flex-col gap-4">
            <TimecardListWithFilters
                surface="project"
                showTotalsByDefault
                passiveFilters={`matter.id=in=(${joinedMatterIds})`}
                paginatedFieldPassiveFilters={[
                    {
                        filterId: 'matterIdInFilter',
                        filters: `id=in=(${joinedMatterIds})`,
                        filterOperator: RSQL_AND,
                    },
                ]}
            />
        </div>
    );
};

export default TimecardsView;
